var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesktopLg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1106,
    height: 802,
    viewBox: "0 0 1106 802",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M879.823 287.217L1097.19 161.11L947.912 78.0293L741.637 199.564",
    stroke: "white",
    strokeWidth: 7.64671,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M741.631 199.565L738.336 201.503",
    stroke: "white",
    strokeWidth: 7.64671,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M731.911 205.286L619.52 271.507",
    stroke: "white",
    strokeWidth: 7.64671,
    strokeMiterlimit: 10,
    strokeDasharray: "11.6 11.6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M616.303 273.399L613.008 275.337L616.315 277.252",
    stroke: "white",
    strokeWidth: 7.64671,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M622.855 281.022L750.506 354.624",
    stroke: "white",
    strokeWidth: 7.64671,
    strokeMiterlimit: 10,
    strokeDasharray: "11.6 11.6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M753.781 356.503L757.088 358.418L760.395 356.503",
    stroke: "white",
    strokeWidth: 7.64671,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M767.23 352.535L873.089 291.117",
    stroke: "white",
    strokeWidth: 7.64671,
    strokeMiterlimit: 10,
    strokeDasharray: "11.6 11.6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M876.508 289.133L879.815 287.219",
    stroke: "white",
    strokeWidth: 7.64671,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M613.008 714.087L757.089 797.157L1097.19 599.851L947.908 516.781L613.008 714.087Z",
    stroke: "#231F20",
    strokeWidth: 3.81755,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M613.832 714.087L757.913 797.157L1098 599.851L948.733 516.781L613.832 714.087Z",
    stroke: "white",
    strokeWidth: 7.64671,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M757.094 576.226V797.156",
    stroke: "white",
    strokeWidth: 7.64671,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M946.609 78.0293V516.781",
    stroke: "white",
    strokeWidth: 7.64671,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1097.04 160.971V599.711",
    stroke: "white",
    strokeWidth: 7.64671,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M613.008 499.109V712.637",
    stroke: "white",
    strokeWidth: 7.64671,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M613.008 273.896V499.109",
    stroke: "white",
    strokeWidth: 7.64671,
    strokeMiterlimit: 10,
    strokeDasharray: "11.6 11.6"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M239.1 320.288C275.013 320.288 304.126 291.175 304.126 255.262C304.126 219.349 275.013 190.236 239.1 190.236C203.187 190.236 174.074 219.349 174.074 255.262C174.074 291.175 203.187 320.288 239.1 320.288Z",
    fill: "#F8EB30"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M713.205 577.248L741.634 593.621L741.576 671.167L712.637 653.901L713.205 577.248Z",
    stroke: "white",
    strokeWidth: 1.91458,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M672.963 553.229L701.392 569.602L701.334 647.16L672.395 629.894L672.963 553.229Z",
    stroke: "white",
    strokeWidth: 1.91458,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M634.397 529.267L662.825 545.639L662.767 623.197L633.828 605.931L634.397 529.267Z",
    stroke: "white",
    strokeWidth: 1.91458,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M713.205 671.166L741.634 687.55L741.576 765.096L712.637 747.83L713.205 671.166Z",
    stroke: "white",
    strokeWidth: 1.91458,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M672.963 647.159L701.392 663.532L701.334 741.078L672.395 723.812L672.963 647.159Z",
    stroke: "white",
    strokeWidth: 1.91458,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M634.397 623.198L662.825 639.571L662.767 717.117L633.828 699.851L634.397 623.198Z",
    stroke: "white",
    strokeWidth: 1.91458,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M815.758 544.7L758.773 577.561L624.266 499.527L683.304 466.666L815.758 544.7Z",
    fill: "#F8EB30"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M871.27 435.14L814.274 468.001L679.766 389.956L738.804 357.106L871.27 435.14Z",
    fill: "#F8EB30"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M0.679688 120.418C8.46564 120.418 704.572 508.451 704.572 508.451L1057.31 2.0625",
    stroke: "#F8EB30",
    strokeWidth: 3.81755,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M757.094 577.562V797.158",
    stroke: "white",
    strokeWidth: 7.64671,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M757.094 358.417V577.561",
    stroke: "white",
    strokeWidth: 7.64671,
    strokeMiterlimit: 10,
    strokeDasharray: "11.6 11.6"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopLg);
export default __webpack_public_path__ + "static/media/desktop-lg.a0da29d7198e5ff32560f5fcd0827de0.svg";
export { ForwardRef as ReactComponent };